var _defs, _circle, _path, _circle2, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 141.73 141.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{opacity:0.39;fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 29.15,
    y1: 76.65,
    x2: 102.35,
    y2: 76.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0ddea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6bcbd2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 53.98,
    y1: 83.01,
    x2: 4.99,
    y2: 104.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#47bdc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00737c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 33.65,
    y1: 71.54,
    x2: 106.86,
    y2: 71.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 59.09,
    y1: 77.47,
    x2: 11.26,
    y2: 98.51,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 93.12,
    y1: 58.53,
    x2: 51.07,
    y2: 84.74,
    xlinkHref: "#linear-gradient-2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 4 copy 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 65.75,
    cy: 76.65,
    r: 36.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.29,108.35a36.59,36.59,0,0,1-29-58.89c-7.43,6.7-13.11,17.4-13.11,28.19a36.61,36.61,0,0,0,36.6,36.61c11.83,0,23.34-6.62,30-15.32A36.44,36.44,0,0,1,70.29,108.35Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 70.25,
    cy: 71.54,
    r: 36.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.79,103.24a36.6,36.6,0,0,1-29-58.89A36.6,36.6,0,1,0,99.28,93.83,36.44,36.44,0,0,1,74.79,103.24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77.87,63.1l-.32,4L56.18,74.8l0-3.89Zm-.58,7.73-.4,4.07-18.3,6.6,0-3.94Zm1.48-18-.53,5.61a15.38,15.38,0,0,0-2.18-.56,12.05,12.05,0,0,0-2.52-.19,9,9,0,0,0-2.75.56A7.73,7.73,0,0,0,67,61.08,8.71,8.71,0,0,0,65.52,66a18.55,18.55,0,0,0,1.3,6.87,18.28,18.28,0,0,0,3.38,6.11,8.62,8.62,0,0,0,4.24,2.77,7.86,7.86,0,0,0,4.68-.29A9.12,9.12,0,0,0,81.6,80.1a10.6,10.6,0,0,0,1.81-1.71,13.64,13.64,0,0,0,1.25-1.72l4,4a12.42,12.42,0,0,1-3.15,3.68,16,16,0,0,1-4.46,2.46,14.19,14.19,0,0,1-8,.61,14.45,14.45,0,0,1-7.08-4A22.29,22.29,0,0,1,60.88,75a22.43,22.43,0,0,1-1.48-9.75,14.58,14.58,0,0,1,2.88-7.63,14.08,14.08,0,0,1,6.57-4.67A14.64,14.64,0,0,1,73.94,52,14.13,14.13,0,0,1,78.77,52.87Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.3d0cc9ae2e5d10dc40a9f2b06239f3be.svg";
export { ForwardRef as ReactComponent };